<template>
    <div width='100%'>
        <!-- <p>ダウンロード先</p> -->
        <el-table :data="products" :show-header="false" style="width: 100%">
            <el-table-column prop="name" width='140px'></el-table-column>
            <el-table-column width='650px'>
                <template slot-scope="props">
                    <p v-for="(item1,index1) in props.row.desc" :key="index1">
                        {{". " + item1}}
                    </p>
                    <p v-for="(item2,index2) in props.row.links" :key="index2" v-html='item2'>
                    </p>
                </template>
            </el-table-column>
        </el-table>
        <el-table :data="Purchase" :show-header="false" style="width: 100%" :row-key="getRowKeys" :expand-row-keys="expands" @row-click="rowClick">
            <el-table-column prop="name" width='100px'></el-table-column>
            <el-table-column type='expand' width='50px'>
                  <template scope="props">
                    <p v-for="(item,index) in props.row.steps" :key="index" v-html="index+1 +'. '+item"></p>
                    </template>
                </el-table-column>
            <el-table-column prop="subtitle" width='600px'>
            </el-table-column>

        </el-table>
        <el-alert :title="day30trial" type="info" show-icon>
  </el-alert>
    </div>
</template>

<script>
export default {
  data: function () {
    return {
      expands: [],
      day30trial: '30日間全機能の試用が可能です、どうぞご購入前にご試用いただければありがたいです',
      products: [{
        name: '標準版',
        desc: [
          '標準版は32ビットOSも64ビットOSもサポートしています、インストール必要ないが、最大処理ファイルは３０MB以下になります。',
          '（32ビットをサポートするため、利用可能メモリの制限があります）'
        ],
        links: [
          '<a href="https://www.vector.co.jp/download/file/winnt/util/fh762261.html">標準版(Version6.1.1.2)のダウンロード(zip)　<=ダウンロードしたら展開を忘れないで下さい</a>',
          '<a href="https://www.vector.co.jp/download/file/winnt/util/fh762262.html">標準版(Version6.1.1.2)のダウンロード(exe)</a>',
          '<a href="http://www.searchplusplus.jp/download/6112/DataToolStd6112.zip">一括検索ツールのダウンロード(zip)</a>'
        ],
        guide: '標準版簡単導入の手引き'
      },
      {
        name: 'Pro版（従来版）',
        desc: [
          'Pro版は64ビットOSだけサポートしています、インストール必要ですが、64ビットOSの能力を発揮できて、大きいサイズのファイルも処理できます。',
          '（例: デフォルト設定で、５００MB自炊PDF処理できます）'
        ],
        links: [
          '<a href="https://www.searchplusplus.jp/download/6112/SearchPro6112.zip">Pro版(Version6.1.1.2)のダウンロード(zip)　<=ダウンロードしたら展開を忘れないで下さい</a>',
          '<a href="https://www.searchplusplus.jp/download/6112/SearchPro6112_J.exe">Pro版(Version6.1.1.2)のダウンロード(exe)</a>',
          '<a href="http://www.searchplusplus.jp/download/6112/DataToolPro6112.zip">一括検索ツールのダウンロード(zip)</a>'
        ],
        guide: 'Pro版簡単導入の手引き'
      },
      {
        name: 'Pro版(新Web UI版)',
        desc: [
          'Web UI版はWin7以降64ビットOSだけご利用できます、インストール必要ないです'
        ],
        links: [
          '<a href="https://www.vector.co.jp/download/file/winnt/util/fh763167.html">Web版(Version6.1.1.1)のダウンロード(zip)　<=ダウンロードしたら展開を忘れないで下さい</a>',
          '<a href="https://www.vector.co.jp/download/file/winnt/util/fh763164.html">Web版(Version6.1.1.1)のダウンロード(exe)</a>'
        ],
        guide: 'Pro版簡単導入の手引き'
      },
      {
        name: 'Mac版',
        desc: [
          'Mac OS用のバージョンです。dmgファイルをクリックしてApplicationsフォルダへコピーしてください。完了したら、Applicationsフォルダ下のSearchpluplus.appを起動すれば結構です。'
        ],
        links: [
          '<a href="http://www.searchplusplus.jp/download/6101/SearchMac6101.dmg">Mac版(Version6.1.0.1)のダウンロード(dmg)</a>'
        ],
        guide: ''
      }],

      Purchase: [{
        id: '0',
        name: '購入方法一',
        subtitle: '作者へ直接連絡してからのご購入',
        steps: [
          '購入したい旨を問い合わせ先( support@searchplusplus.jp)にメールをください',
          '当方より代金(標準版税込み:3410円、Pro版税込み:5602円、Mac版税込み:5602円)の振込先の銀行口座を連絡します',
          '指定口座へ代金の振込みをお願いします',
          '振込みが完了しましたら、その旨、メールにて連絡くださった当方が振込みを確認いたしましたら、ライセンス情報およびダウンロード先をメールにて送付いたします'
        ]
      },
      {
        id: '1',
        name: '購入方法二',
        subtitle: 'Paypal経由でクレジットカードで払う',
        steps: [
          ['下記アイコンをクリックして、Paypal社の購入画面に行きます（標準版税込み:3410円、Pro版税込み:5602円、Mac版税込み:5602円）',
            '<div style="display:flex;">',
            // Std Version paypal
            '<h4 style="color:DarkBlue;font-weight:bold">標準版</h4>',
            '<form target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">',
            '<input type="hidden" name="cmd" value="_s-xclick">',
            '<input type="hidden" name="hosted_button_id" value="KECBBA27LQ6GJ">',
            '<input type="image" src="http://www.searchplusplus.jp/stdbuy.png" border="0" name="submit" alt="PayPal - オンラインでより安全・簡単にお支払い">',
            '<img alt="" border="0" title="標準版" src="https://www.paypalobjects.com/en_GB/i/scr/pixel.gif" width="1" height="1">',
            '</form>',
            // Pro Version Paypal
            '<h4 style="color:ForestGreen;font-weight:bold;padding-left: 10px">Pro版</h4>',
            '<form target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">',
            '<input type="hidden" name="cmd" value="_s-xclick">',
            '<input type="hidden" name="hosted_button_id" value="ETWN4J2CB5E9A">',
            '<input type="image" src="http://www.searchplusplus.jp/probuy.png" border="0" name="submit" alt="PayPal - オンラインでより安全・簡単にお支払い">',
            '<img alt="" border="0" title="Pro版" src="https://www.paypalobjects.com/en_GB/i/scr/pixel.gif" width="1" height="1">',
            '</form>',
            // mac Verson paypal
            '<h4 style="color:Indigo;font-weight:bold;padding-left: 10px">Mac版</h4>',
            '<form target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">',
            '<input type="hidden" name="cmd" value="_s-xclick">',
            '<input type="hidden" name="hosted_button_id" value="723FVNH3H89PN">',
            '<input type="image" src="http://www.searchplusplus.jp/macbuy.png" border="0" name="submit" alt="PayPal - オンラインでより安全・簡単にお支払い">',
            '<img alt="" border="0" title="Mac版" src="https://www.paypalobjects.com/en_GB/i/scr/pixel.gif" width="1" height="1">',
            '</form>',
            '</div>'
          ].join('\n'),
          '数量を設定して、「更新」ボタンをおして、金額を更新します',
          '「Paypalでチェックアウト」ボタンを押して、次の画面に行きます',
          '「クレジットカードで支払う」リンクをクリックして、カード情報、Eメールアドレスを入れて、「支払う」ボタンを押しますと、Paypal社から連絡メールが当方に来ます',
          '当方はPaypalからの連絡が着たら、ライセンスキーをステップ３で登録した Eメールアドレス当てに送付いたします'
        ]
      },
      {
        id: '2',
        name: '購入方法三',
        subtitle: 'Vector社経由でのご購入（標準版税込み＋レジ手数料:3410円、Pro版税込み＋レジ手数料:5602円、Mac版税込み＋レジ手数料:5602円）',
        steps: [
          '<a href="http://s.shop.vector.co.jp/service/servlet/NCart.Add?ITEM_NO=SR296240">標準版の購入</a>',
          '<a href="http://s.shop.vector.co.jp/service/servlet/NCart.Add?ITEM_NO=SR378160">Pro版の購入</a>',
          '<a href="http://s.shop.vector.co.jp/service/servlet/NCart.Add?ITEM_NO=SR442842">Mac版の購入</a>'
        ]
      }
      ]
    }
  },
  methods: {
    getRowKeys (row) {
      return row.id
    },
    rowClick (row) {
      if (row.id === this.expands[0]) { // collapsed
        this.expands = []
      } else { // expand
        this.expands = []
        this.expands.push(row.id)
      }
    }
  }
}
</script>

<style scoped>
.el-table__header {
  width: 100% !important;
  /* width: 850px; */
}

.el-table__body {
  width: 100% !important;
  /* width: 850px; */
}
</style>
